













import { defineComponent } from "@vue/composition-api";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";

export default defineComponent({
  name: "DeleteRewardConfirm",
  components: { BaseButton, BaseConfirm },
  props: {
    show: { type: Boolean, required: true },
    loading: { type: Boolean, default: false },
    showNoteForActive: { type: Boolean, default: false },
  },
});
